import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {UnrAuthGuard} from './core/guards/auth.guard';
import {UnrLoginGuard} from './pages/login/login.guard';
import {MyRoutesPage} from './pages/my-routes/my-routes';
import {NoConnectionComponent} from './pages/no-connection/no-connection.component';
import {UnrProfilePage} from './pages/profile/profile';
import {RoadtripDetailsPage} from './pages/roadtrip-details/roadtrip-details.page';
import {SettingsPage} from './pages/settings/settings';
import {StepDetailsPage} from './pages/step-details/step-details';
import {TutorialPage} from './pages/tutorial/tutorial';
import {PrivacyPage} from './pages/privacy/privacy';
import {OfflineGuard} from './shared/guards/offline.guard';
import {WelcomePage} from './pages/welcome/welcome';
import {WelcomeGuard} from './pages/welcome/welcome.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [UnrLoginGuard, OfflineGuard],
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'welcome',
    canActivate: [WelcomeGuard],
    component: WelcomePage
  },
  {
    path: 'no-connection',
    component: NoConnectionComponent
  },
  {
    path: 'roadtrips',
    canActivate: [UnrAuthGuard, OfflineGuard],
    loadChildren: () => import('./pages/roadtrip-list-tabs/roadtrip-list-tabs.module').then(m => m.RoadtripListTabsComponentModule)
  },
  {
    path: 'triprecorder',
    canActivate: [UnrAuthGuard, OfflineGuard],
    loadChildren: () => import('./pages/triprecorder/trip-recorder.module').then(m => m.TripRecorderModule)
  },
  {
    path: 'roadtrip-details',
    canActivate: [UnrAuthGuard, OfflineGuard],
    component: RoadtripDetailsPage
  },
  {
    path: 'step-details',
    canActivate: [UnrAuthGuard, OfflineGuard],
    component: StepDetailsPage
  },
  {
    path: 'tutorial',
    canActivate: [UnrAuthGuard, OfflineGuard],
    component: TutorialPage
  },
  {
    path: 'privacy',
    canActivate: [UnrAuthGuard, OfflineGuard],
    component: PrivacyPage
  },
  {
    path: 'my-routes',
    canActivate: [UnrAuthGuard, OfflineGuard],
    component: MyRoutesPage
  },
  {
    path: 'profile',
    canActivate: [UnrAuthGuard, OfflineGuard],
    component: UnrProfilePage
  },
  {
    path: 'settings',
    canActivate: [UnrAuthGuard, OfflineGuard],
    component: SettingsPage
  },
  { path: 'adsmodal',
  loadChildren: () => import('./adsmodal/adsmodal.module').then(m => m.AdsmodalPageModule)
 },
  {
    path: 'timeline',
    loadChildren: () => import('./pages/timeline/timeline.module').then( m => m.TimelinePageModule)
  },
  {
    path: 'add-timeline',
    loadChildren: () => import('./pages/add-timeline/add-timeline.module').then( m => m.AddTimelinePageModule)
  },
  {
    path: 'userlocation',
    loadChildren: () => import('./pages/userlocation/userlocation.module').then( m => m.UserlocationPageModule)
  }


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
